<template>
  <div>
    <v-btn color="error" class="ml-5 text--white" @click="isShowNotInvalidDialog = true">
      反作廢
    </v-btn>
    <v-dialog persistent v-model="isShowNotInvalidDialog" max-width="600px">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <ValidationObserver ref="notInvalidQuotation">
            <v-row>
              <v-col cols="12">
                <ValidationProvider
                  name="反作廢原因"
                  :rules="{ required: true }"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    outlined
                    v-model="notInvalidReason"
                    :error-messages="errors[0]"
                    :disabled="isLoading"
                  >
                    <template v-slot:label>
                      <span class="red--text">
                        <strong>* </strong>
                      </span>
                      反作廢原因
                    </template>
                  </v-textarea>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <date-picker-exp-date
                  :dateName="'quotation_exp_date'"
                  :isAllTextFieldDisabled="isLoading"
                  :createTime="editedQuotation.ExpDate"
                  :expDate="expTime"
                  @setDate="setExpTime"
                />
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="closeNotInvalidDialog" :disabled="isLoading">
            {{ $t('common_close') }}
          </v-btn>
          <v-btn color="success" text @click="NotInvalidBtn" :loading="isLoading">
            {{ $t('common_confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { HttpQuotation } from '@/js/http-Manager'
import DatePickerExpDate from '@/components/DatePickerExpDate.vue'
export default {
  components: { DatePickerExpDate },
  name: 'NotInvalidBtn',
  props: {
    editedQuotation: {
      type: Object
    },
    isAllTextFieldDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isShowNotInvalidDialog: false,
    expTime: 0,
    notInvalidReason: '',
    isLoading: false
  }),
  mounted () {},
  watch: {},
  computed: {},
  methods: {
    setExpTime (val) {
      this.expTime = val * 1
    },
    closeNotInvalidDialog () {
      this.isShowNotInvalidDialog = false
    },
    async NotInvalidBtn () {
      const isValid = await this.$refs.notInvalidQuotation.validate()
      if (!isValid) return
      this.isLoading = true
      await HttpQuotation.UpdateNotInvalidQuotation({
        Number: this.editedQuotation.Number,
        NotInvalidReason: this.notInvalidReason,
        ExpTime: this.expTime
      })
      this.isLoading = false
      this.$emit('searchEditQuotation')
      this.closeNotInvalidDialog()
    }
  }
}
</script>
